module.exports = __webpack_public_path__ + "media/images/markers/puc-2d01f3af8791558086a61448404472a0.png";